/* eslint-disable @typescript-eslint/camelcase */
import Service from "./core/Service";
import { config } from "@/config";
import { UserManager, WebStorageStateStore } from "oidc-client";
import { User } from "bancojs";
/**
 * State for AuthenticationService
 */
type AuthenticationState = {
  client: UserManager;
  accessToken: string | null;
  currentUser: User | null;
};
/**
 * Wraps OIDC functionality for user authentication and authorization.
 */
class AuthenticationService extends Service<AuthenticationState> {
  protected state: AuthenticationState;

  constructor() {
    super();
    this.state = {
      currentUser: null,
      accessToken: null,
      client: new UserManager({
        userStore: new WebStorageStateStore({
          store: window.localStorage,
        }),
        authority: config.oidc.authority,
        client_id: config.oidc.client_id,
        redirect_uri: window.location.origin + config.path + "/auth-callback.html",
        response_mode: "fragment",
        automaticSilentRenew: true,
        loadUserInfo: false,
        validateSubOnSilentRenew: false,
        silent_redirect_uri: window.location.origin + config.path + "/silent-renew.html",
        response_type: "code",
        scope: config.oidc.scopes,
        post_logout_redirect_uri: window.location.origin + config.path + "/?notify=logout",
        filterProtocolClaims: true,
      }),
    };
    this.state.client.events.addUserLoaded((user) => {
      this.state.accessToken = user.access_token;
    });
    this.state.client.events.addUserUnloaded(() => {
      this.state.accessToken = null;
      this.state.currentUser = null;
    });
    this.state.client.events.addUserSignedOut(() => {
      this.state.accessToken = null;
      this.state.currentUser = null;
    });
    this.state.client.events.addAccessTokenExpiring(() => {
      // Wait 2 minutes for silent renew and set access token
      console.log("Token is expiring. Queueing silent renew...");
      setTimeout(async () => {
        const user = await this.state.client.getUser();
        this.state.accessToken = user ? user.access_token : null;
      }, 30000);
    });
  }

  get accessToken() {
    return this.state.accessToken;
  }

  set accessToken(val) {
    this.setState({ accessToken: val });
    //this.state.accessToken = val;
  }

  get currentUser() {
    return this.state.currentUser;
  }

  set currentUser(val) {
    this.setState({ currentUser: val });
    //this.state.currentUser = val;
  }
  /**
   * Returns true if currentUser has at least one ADMIN type role.
   */
  hasAnyAdmin() {
    if (!this.state.currentUser || !this.state.currentUser.roles) return false;
    const out = this.state.currentUser.roles.filter((el) => {
      return el.includes("ADMIN");
    });
    return out.length > 0;
  }

  public getIdentity() {
    return this.state.client.getUser();
  }

  public removeIdentity() {
    return this.state.client.removeUser();
  }

  public clearStaleState() {
    return this.state.client.clearStaleState();
  }

  public login(args?: any) {
    return this.state.client.signinRedirect(args);
  }

  public silentLogin(args?: any) {
    return this.state.client.signinSilent(args);
  }

  public logout(args?: any) {
    return this.state.client.signoutRedirect(args);
  }
}

export const $auth = Service.singleton(AuthenticationService);
